import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useNotificationContext } from "contexts/NotificationContext";
import { useNavigate } from "react-router-dom";
import { RouteName } from "constants/route";
import { createFaqApi } from "api/faq";
import { IFaqInput } from "models/faq";
import createFaqValidator from "validators/createFaq.validator";

export default function useCreateFaq() {
  const navigate = useNavigate();
  const { showError, showSuccess } = useNotificationContext();
  const [loading, setLoading] = useState<boolean>(false);
  const { control, handleSubmit } = useForm<IFaqInput>({
    resolver: yupResolver(createFaqValidator),
  });

  const onSubmit = async (input: IFaqInput) => {
    setLoading(true);
    const { data, error } = await createFaqApi(input);
    if (data) {
      showSuccess("Faq created Successfully");
      navigate(RouteName.FAQ, { replace: true });
    } else {
      showError(error!.message);
    }
    setLoading(false);
  };

  return { handleSubmit, onSubmit, control, loading };
}
